import React, { FC } from 'react';
import classNames from 'classnames';
import { VideoStatusKey } from './videoStatus';

/** §02: status = filled pill with a dot and sentence case. */
const SPEC: Record<VideoStatusKey, { bg: string; fg: string; dot: string }> = {
  // Same neutral wash as production: the slot is idle, not in review.
  pending: { bg: 'var(--surface-2)', fg: 'var(--text-2)', dot: 'var(--muted)' },
  production: { bg: 'var(--surface-2)', fg: 'var(--text)', dot: 'var(--muted)' },
  unapproved: { bg: 'var(--tint)', fg: 'var(--accent-text)', dot: 'var(--accent)' },
  approved: { bg: 'var(--up-bg)', fg: 'var(--up)', dot: 'var(--up)' },
};

export const StatusPill: FC<{ status: VideoStatusKey; label: string }> = ({ status, label }) => {
  const s = SPEC[status];
  return (
    <span
      className="inline-flex items-center gap-1.5 h-6 px-2.5 rounded-full font-bold whitespace-nowrap shrink-0"
      style={{ background: s.bg, color: s.fg, fontSize: 11.5 }}
    >
      <i className="w-1.5 h-1.5 rounded-full shrink-0" style={{ background: s.dot }} />
      {label}
    </span>
  );
};

/** §02: flag = outlined, uppercase, dotless. Gold for Demo, neutral for Non-project. */
export const FlagChip: FC<{ label: string; gold?: boolean; compact?: boolean }> = ({ label, gold, compact }) => (
  <span
    className={classNames(
      'inline-flex items-center px-2 border font-bold uppercase whitespace-nowrap shrink-0',
      compact ? 'h-[21px] rounded-md' : 'h-6 rounded-full'
    )}
    style={{
      borderColor: gold ? 'var(--accent)' : 'var(--border)',
      color: gold ? 'var(--accent-text)' : 'var(--text-2)',
      fontSize: 10,
      letterSpacing: '.1em',
      background: 'transparent',
    }}
  >
    {label}
  </span>
);
